export const TickIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M16.6668 5L7.50016 14.1667L3.3335 10" stroke="#0090EA" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
}